<ng-container *ngIf="!hideLayout">
  <sm-header (onToggle)="sideNav.toggle()"></sm-header>
</ng-container>

<mat-sidenav-container>
  <mat-sidenav
    *ngIf="!hideLayout"
    role="navigation"
    autoFocus="false"
    [opened]="sideNavState"
    fixedInViewport
    [fixedTopGap]="bodyOffset"
    [mode]="'over'"
  >
    <sm-sidebar (closeSidenav)="sideNav.close()"></sm-sidebar>
  </mat-sidenav>

  <mat-sidenav-content role="main" [ngStyle]="{'margin-top': !hideLayout ?  '64px' : '0px'}">
    <div class="body-offset" [ngClass]="{ 'p-4': !hideLayout }">
      
<!--       
      <div class="pull-to-refresh-wrapper"
           (touchstart)="onTouchStart($event)"
           (touchmove)="onTouchMove($event)"
           (touchend)="onTouchEnd()">

        
        <div class="refresh-spinner" [class.active]="isRefreshing || pullProgress > 0">
       
          <div *ngIf="!isRefreshing && pullProgress > 0" class="rotating-icon"
               [style.transform]="'rotate(' + pullProgress * 3 + 'deg)'">
            <mat-icon>sync</mat-icon>
          </div>
        
          <mat-progress-spinner
            *ngIf="isRefreshing"
            mode="indeterminate"
            diameter="24">
          </mat-progress-spinner>
        </div>
        

        <div class="content-area scrollable-content">
          <router-outlet></router-outlet>
        </div>
      </div> -->
      <router-outlet></router-outlet>
    </div>
  </mat-sidenav-content>
</mat-sidenav-container>

<sm-loader></sm-loader>
<sm-auto-login-loader></sm-auto-login-loader>
